import React, { useState, useEffect } from 'react';

export type TabState = 'quotation' | 'partnerInfo';

interface UseActiveTab {
  quotationId: string;
}

const useActiveTab = ({
  quotationId
}: UseActiveTab): [
  TabState,
  React.Dispatch<React.SetStateAction<TabState>>
] => {
  const [activeTab, setActiveTab] = useState<TabState>('partnerInfo');

  useEffect(() => {
    if (quotationId) {
      return setActiveTab('quotation');
    }

    return setActiveTab('partnerInfo');
  }, [quotationId]);

  return [activeTab, setActiveTab];
};

export default useActiveTab;
